import LogoDiadWhite from "../../../assets/logodiadunjbgwhite.png";
import { Dropdown, Menu, message } from "antd";
import { MenuOutlined, UserOutlined, LogoutOutlined } from "@ant-design/icons";
import { logout } from "../../../api/auth";
import { useHistory } from "react-router-dom";

const handleLogout = () => {
  message.info("¡Hasta luego!");
  logout();
  window.location.reload();
};

const menu = (
  <Menu onClick={handleLogout}>
    <Menu.Item key="1" icon={<LogoutOutlined />}>
      Cerrar sesión
    </Menu.Item>
  </Menu>
);

/**
 * HeaderIngresante
 * @param {Object} user
 * @param {Function} showDrawer
 * @param {String} headerTitle
 * @returns
 */
function HeaderIngresante(props) {
  const { user, showDrawer = null, headerTitle = "" } = props;
  const history = useHistory();

  return (
    <header
      className="flex justify-between items-center w-full h-16 p-4"
      style={{ background: "#D41D3D" }}
    >
      <span className="flex items-center">
        {showDrawer && (
          <span className="mr-4 md:hidden">
            <button onClick={showDrawer}>
              <MenuOutlined className="text-white" />
            </button>
          </span>
        )}
        <button onClick={() => history.push("/")}>
          <img src={LogoDiadWhite} width={150} alt="Logo DIAD-UNJBG" />
        </button>
      </span>
      <h1 className="hidden md:block text-white font-semibold text-lg">
        {headerTitle}
      </h1>
      <Dropdown.Button
        overlay={menu}
        trigger={["click"]}
        placement="bottomLeft"
        icon={<UserOutlined />}
      >
        {user.firstName || "Usuario"}
      </Dropdown.Button>
    </header>
  );
}

export default HeaderIngresante;
